import { NpiPreDetectEvent } from './npi-pre-detect.event';
import { AdSet } from '../../../entities/ad-set';
import { Npi } from '../../../entities/npi';
import { NpiSourceInterface } from '../../../interfaces/components/npi/npi-source.interface';

export class NpiPostDetectEvent extends NpiPreDetectEvent {
  public constructor (
    private readonly npi: Npi,
    protected override readonly adSet: AdSet,
    protected override readonly source: NpiSourceInterface,
  ) {
    super(adSet, source);
  }

  public getNpi (): Npi {
    return this.npi;
  }
}
